import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Pakistani CNIC generator following Single Responsibility Principle
 */
export class PkGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true } = options;

    // Generate first 12 digits
    const digits = this.randomDigits(12);
    
    // Calculate check digit
    const weights = [6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 7];
    let sum = 0;

    for (let i = 0; i < 12; i++) {
      sum += parseInt(digits[i]) * weights[i];
    }

    const remainder = sum % 11;
    const checkDigit = remainder < 2 ? remainder : 11 - remainder;
    
    const cnic = digits + checkDigit;
    
    return formatted ? 
      `${cnic.substring(0, 5)}-${cnic.substring(5, 12)}-${cnic.substring(12, 13)}` : 
      cnic;
  }
}